<div class="summary" id="summary-page">
  <div class="titles-container only-pdf">
    <div class="title-div">
      <img class="jumper-logo" src="assets/images/smokejumperLogoNoSubtitle.png" alt="Smokejumper Logo">
    </div>
    <span class="second-title">| Smokejumper Reporting System</span>
  </div>
  <div class="card">
    <div class="top-row">
      <div class="title-container">
        <span class="title">Incident ID: {{ form.get('incidentId').value !== 0 ? form.get('incidentId').value : 0 }}</span>
        <div class="status-chip" [ngClass]="form.get('status').value === 1 ? 'finalized' : 'draft'">
          <mat-icon class="only-web">{{ form.get('status').value === 1 ? 'check_circle' : 'schedule' }}</mat-icon>
          <span class="chip" >{{ form.get('status').value === 1 ? 'Finalized' : 'Draft' }}</span>
        </div>
      </div>
      <button class="primary-btn pdf-btn" mat-raised-button (click)="printToPdf()">Print to PDF</button>
    </div>
    <div class="detail-section grey-container">
      <div class="detail-row">
        <div class="detail-col">
          <span class="label">Created by</span>
          <span class="info">{{ form.get('createUser')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Edited by</span>
          <span class="info">{{ form.get('modifyUser')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Created date</span>
          <span class="info">{{ formatDate(form.get('createDate')?.value) }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Edit Date</span>
          <span class="info">{{ formatDate(form.get('modifyDate')?.value) }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="card">

    <div class="detail-section">
      <div class="numbered-row">
        <span class="number"></span>
        <span class="sub-title">Malfunction Incident</span>
      </div>
      <div class="detail-row">
        <div class="detail-col">
          <span class="label">Malfunction Date</span>
          <span class="info">{{ form.get('malfunctionDate')?.value ? formatDate(form.get('malfunctionDate')?.value) : '' }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Base</span>
          <span class="info">{{ (form.get('homeBase1Details')?.value?.text || '') + (form.get('homeBase1Details')?.value?.text ? ' | ' : '') + (form.get('homeBase1Details')?.value?.baseCode || '') }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Spike Base</span>
          <span class="info">{{ form.get('spikeBaseDetails')?.value ? (form.get('spikeBaseDetails')?.value?.name + ' | ' +  form.get('spikeBaseDetails')?.value?.code) : form.get('spikeBaseId')?.value }}</span>
        </div>
        <div class="detail-col">
          <span *ngIf="form.get('incorrectProcedure')?.value" class="label ">
            <mat-icon class="check-icon">check_circle</mat-icon>
            <span class="only-pdf">{{ ' ✓ ' }}</span>
            Incorrect Procedure
          </span>
          <span *ngIf="form.get('inServiceError')?.value" class="label ">
            <mat-icon class="check-icon">check_circle</mat-icon>
            <span class="only-pdf">{{ ' ✓ ' }}</span>
            In-Service Error
          </span>
          <span *ngIf="form.get('inspectionError')?.value" class="label ">
            <mat-icon class="check-icon">check_circle</mat-icon>
            <span class="only-pdf">{{ ' ✓ ' }}</span>
            Inspection Error
          </span>
          <span *ngIf="form.get('manufacturingError')?.value" class="label ">
            <mat-icon class="check-icon">check_circle</mat-icon>
            <span class="only-pdf">{{ ' ✓ ' }}</span>
            Manufacturing Error
          </span>
          <span *ngIf="form.get('cargoInTow')?.value" class="label ">
            <mat-icon class="check-icon">check_circle</mat-icon>
            <span class="only-pdf">{{ ' ✓ ' }}</span>
            Cargo-in-Tow
          </span>
        </div>
        <div class="detail-col">
          <span class="label">Classification</span>
          <span class="info">{{ form.get('classificationName')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">MARS Type</span>
          <span class="info">{{ form.get('classificationTypeName')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Category</span>
          <span class="info">{{ form.get('categoryName')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Malfunction Type</span>
          <span class="info">{{ form.get('malfunctionTypeName')?.value}}</span>
        </div>
      </div>
      <span class="section-title">Master Action Information</span>
      <div class="detail-row">
        <div class="detail-col">
          <span class="label">MADB Incident</span>
          <span class="info">{{ form.get('madbIncident')?.value?._nameofIncident || form.get('madbIncident')?.value?.incidentName}}</span>
        </div>
        <div class="detail-col">
          <span class="label">Mission</span>
          <span class="info">{{ form.get('mission')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Mode</span>
          <span class="info">{{ form.get('mode')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">To Area</span>
          <span class="info">{{ form.get('toAreaName')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Yards of Drift</span>
          <span class="info">{{ form.get('yardsDrift')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Aircraft</span>
          <span class="info">{{ form.get('aircraft')?.value?.Aircraft_Name }}</span>
        </div>
      </div>
      <div class="detail-row">
        <div class="detail-col">
          <span class="label">Jump Type</span>
          <span class="info">{{ form.get('jumpType')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Fire Name</span>
          <span class="info">{{ form.get('fireName')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Jump Elevation</span>
          <span class="info">{{ form.get('jumpSpotElevationMSL')?.value ? form.get('jumpSpotElevationMSL')?.value + ' ft' : '' }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Streamer Time</span>
          <span class="info">{{ form.get('streamerTime')?.value ? form.get('jumpSpotElevationMSL')?.value + ' sec' : '' }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Temperature</span>
          <span class="info">{{ form.get('temp')?.value ? form.get('temp')?.value + '°F' : '' }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="detail-section">
      <div class="numbered-row">
        <span class="number"></span>
        <span class="sub-title">Jumper</span>
      </div>
      <div class="detail-row">
        <div class="detail-col">
          <span class="label">Jumper Home Base</span>
          <span class="info">{{ (form.get('jumperBaseDetails')?.value?.text || '') + (form.get('jumperBaseDetails')?.value?.text ? ' | ' : '') + (form.get('jumperBaseDetails')?.value?.baseCode || '') }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Jumper</span>
          <span class="info">{{ (form.get('jumperDetails')?.value?.firstName || '') + ' ' + (form.get('jumperDetails')?.value?.lastName || '')}}</span>
        </div>
        <div class="detail-col">
          <span class="label">Position In Stick</span>
          <span class="info">{{ form.get('positionInStick')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Exit Weight</span>
          <span class="info">{{ form.get('jumperDetails')?.value?.weight }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Career Jumps to Date</span>
          <span class="info">{{ form.get('jumperDetails')?.value?.totalJumps }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Total Jumps Year to Date</span>
          <span class="info">{{ form.get('jumperDetails')?.value?.seasonJumps }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Days Since Last Jump</span>
          <span class="info">{{ form.get('jumperDetails')?.value?.daysSince }}</span>
        </div>
      </div>
      <div class="detail-row grey-row">
        <div class="detail-col notes">
          <span class="label">Notes</span>
          <span class="info note">{{ form.get('jumperNotes')?.value }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="pagebreak"></div>
  <div class="card">
    <div class="detail-section">
      <div class="numbered-row">
        <span class="number"></span>
        <span class="sub-title">Parachutes</span>
      </div>       
      <span class="section-title">Main</span>
      <div class="detail-row">
        <div class="detail-col">
          <span class="label">Main Parachute deployed</span>
          <span class="info">{{ form.get('mainDeployed')?.value ? 'Yes' : 'No' }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Main Chute Cutaway</span>
          <span class="info">{{ form.get('mainCanopyCutaway')?.value ? 'Yes' : 'No' }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Main Parachute</span>
          <span class="info">{{ form.get('mainParachute')?.value?.chuteType }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Main Manufacturer</span>
          <span class="info">{{ form.get('mainRigManufDetails')?.value?.name }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Jumps to date</span>
          <span class="info">{{ form.get('jumpsOnMain')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">In-Service Date</span>
          <span class="info">{{ form.get('mainInServiceDate')?.value ? formatDate(form.get('mainInServiceDate')?.value) : '' }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Rigger</span>
          <span class="info">{{ form.get('mainRiggerDetails')?.value?.firstName }} {{ form.get('mainRiggerDetails')?.value?.lastName }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Rigging Location</span>
          <span class="info">{{ form.get('mainRigLocDetails')?.value?.text && (form.get('mainRigLocDetails')?.value?.text + ' | ') }}{{ form.get('mainRigLocDetails')?.value?.baseCode }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Rigging Spike</span>
          <span class="info">{{ form.get('mainRiggerSpikeBaseDetails')?.value?.name }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Rigging Date</span>
          <span class="info">{{ form.get('mainRigDate')?.value ? formatDate(form.get('mainRigDate').value) : '' }}</span>
        </div>
      </div>
        <span class="section-title">Drogue</span>
        <div class="detail-row">
          <div class="detail-col">
            <span class="label">Drogue Parachute</span>
            <span class="info">{{ form.get('drgName')?.value?.Base }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Drogue Manufacturer</span>
            <span class="info">{{ form.get('drgManufDetails')?.value?.name }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Harness Number</span>
            <span class="info">{{ form.get('harnessNum')?.value }}</span>
          </div>
          <div class="detail-col">
            <span class="label">In-Service Date</span>
            <span class="info">{{ form.get('drgServiceDate')?.value ? formatDate(form.get('drgServiceDate')?.value) : '' }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Rigger</span>
            <span class="info">{{ form.get('drgRiggerDetails')?.value?.firstName }} {{ form.get('drgRiggerDetails')?.value?.lastName }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Rigging Location</span>
            <span class="info">{{ form.get('drgRigLocationDetails')?.value?.text && (form.get('drgRigLocationDetails')?.value?.text + ' | ') }}{{ form.get('drgRigLocationDetails')?.value?.baseCode }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Rigging (Spike)</span>
            <span class="info">{{ form.get('drgRiggerSpikeBaseDetails')?.value?.name }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Rigging Date</span>
            <span class="info">{{ form.get('drgRiggerDate').value ? formatDate(form.get('drgRiggerDate')?.value) : '' }}</span>
          </div>
        </div>
        <span class="section-title">Reserve</span>
        <div class="detail-row">
          <div class="detail-col">
            <span class="label">Reserve Parachute</span>
            <span class="info">{{ form.get('reserveParachuteDetails')?.value?.Base && (form.get('reserveParachuteDetails')?.value?.Base + ' | ') }}{{ form.get('reserveParachuteDetails')?.value?.reserve }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Reserve Manufacturer</span>
            <span class="info">{{ form.get('reserveRigManufDetails')?.value?.name }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Deployment Method</span>
            <span class="info">{{ form.get('reserveDeployedBy')?.value }}</span>
          </div>
          <div class="detail-col">
            <span class="label">In-Service Date</span>
            <span class="info">{{ form.get('reserveServiceDate')?.value ? formatDate(form.get('reserveServiceDate')?.value) : '' }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Rigger</span>
            <span class="info">{{ form.get('reserveRiggerDetails')?.value?.firstName }} {{ form.get('reserveRiggerDetails')?.value?.lastName }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Rigging Location</span>
            <span class="info">{{ form.get('reserveRigLocDetails')?.value?.text && (form.get('reserveRigLocDetails')?.value?.text + ' | ') }}{{ form.get('reserveRigLocDetails')?.value?.baseCode }}</span>
          </div>
          <div class="detail-col">
            <span class="label">Rigging Date</span>
            <span class="info">{{ form.get('reserveRigDate').value ? formatDate(form.get('reserveRigDate')?.value) : '' }}</span>
          </div>
        </div>
      <div class="detail-row grey-row">
        <div class="detail-col notes">
          <span class="label">Notes</span>
          <span class="info note">{{ form.get('parachuteNotes')?.value }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="pagebreak"></div>
  <div class="card">
    <div class="detail-section">
      <div class="numbered-row">
        <span class="number"></span>
        <span class="sub-title">Artifacts</span>
      </div>       
      <span class="section-title">Text Narratives</span>
      <div class="detail-row">
        <div class="detail-col">
          <span class="label">Witness</span>
          <span class="info">{{ form.get('witness')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Foreman</span>
          <span class="info">{{ form.get('foreman')?.value }}</span>
        </div>
        <div class="detail-col">
          <span class="label">Department</span>
          <span class="info">{{ form.get('responsibleDept')?.value }}</span>
        </div>
      </div>
      <div class="detail-row grey-row gap">
        <div class="detail-col wide">
          <span class="label">Witness Statement</span>
          <span class="info note">{{ form.get('witnessNarrative')?.value }}</span>
        </div>
      </div>
      <div class="detail-row grey-row gap">
        <div class="detail-col wide">
          <span class="label">Jumper Statement</span>
          <span class="info note">{{ form.get('jumperNarrative')?.value }}</span>
        </div>
      </div>
      <div class="detail-row grey-row gap">
        <div class="detail-col wide">
          <span class="label">Conclusion and Corrective Action</span>
          <span class="info note">{{ form.get('conclusion')?.value }}</span>
        </div>
      </div>
      <span class="section-title">Photos and Video</span>
      <div class="media-list">
        <div class="media-container">
          <div class="row">
            <app-card
              *ngIf="form.get('picPreview1')?.value || !form.get('picId1')?.value"
              class="media-card"
              [cardType]="'image-display'"
              [imgSrc]="form.get('picPreview1')?.value"
            ></app-card>
            <app-card
              *ngIf="form.get('picId1')?.value && !form.get('pic1toUpload')?.value"
              class="media-card"
              [cardType]="'image-display'"
              [imgSrc]="relativePathToUploadedFiles + '/' + form.get('picId1')?.value"
            ></app-card>
            <div class="detail-col media-info">
              <span class="label">Photo #1 Description</span>
              <span class="info note">{{ form.get('picDesc1')?.value }}</span>
            </div>
          </div>
        </div>
        <div class="media-container">
          <div class="row">
            <app-card
              *ngIf="form.get('picPreview2')?.value || !form.get('picId2')?.value"
              class="media-card"
              [cardType]="'image-display'"
              [imgSrc]="form.get('picPreview2')?.value"
            ></app-card>
            <app-card
              *ngIf="form.get('picId2')?.value && !form.get('pic2toUpload')?.value"
              class="media-card"
              [cardType]="'image-display'"
              [imgSrc]="relativePathToUploadedFiles + '/' + form.get('picId2')?.value"
            ></app-card>
            <div class="detail-col media-info">
              <span class="label">Photo #2 Description</span>
              <span class="info note">{{ form.get('picDesc2')?.value }}</span>
            </div>
          </div>
        </div>
        <div class="media-container">
          <div class="row">
            <app-card
              *ngIf="form.get('picPreview3')?.value || !form.get('picId3')?.value"
              class="media-card"
              [cardType]="'image-display'"
              [imgSrc]="form.get('picPreview3')?.value"
            ></app-card>
            <app-card
              *ngIf="form.get('picId3')?.value && !form.get('pic3toUpload')?.value"
              class="media-card"
              [cardType]="'image-display'"
              [imgSrc]="relativePathToUploadedFiles + '/' + form.get('picId3')?.value"
            ></app-card>
            <div class="detail-col media-info">
              <span class="label">Photo #3 Description</span>
              <span class="info note">{{ form.get('picDesc3')?.value }}</span>
            </div>
          </div>
        </div>
        <div class="media-container">
          <div class="row">
            <app-card
              *ngIf="!form.get('videoId1')?.value || form.get('videoToUpload')?.value"
              class="media-card"
              [cardType]="'video-display'"
              [videoSrc]="this.form.get('videoPreview')?.value"
              [videoType]="this.form.get('videoType')?.value"
            ></app-card>
            <app-card
              *ngIf="form.get('videoId1')?.value && !form.get('videoToUpload')?.value"
              class="media-card"
              [cardType]="'video-display'"
              [videoSrc]="relativePathToUploadedFiles + '/' + this.form.get('videoId1')?.value"
            ></app-card>
            <div class="detail-col media-info">
              <span class="label">Video Description</span>
              <span class="info note">{{ form.get('videoDesc1')?.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
